// removed by extract-text-webpack-plugin
module.exports = {"hint":"_1shXrsd6vNZVZQCfyV3i9P","button":"_1pOW2rDYvkgM3b9Qp3kVaT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/FormSignin/FormSignin.styl
// module id = 132
// module chunks = 0